import { currency } from '@shared/hooks/currencies';

export const getPlateAmount = data => {
  const { amount, money_type } = data || {};
  if (!amount) {
    return 'Consultanos';
  }

  const code = money_type?.name?.toUpperCase();
  if (!code) {
    return '';
  }

  const isInUSD = ['USD', 'GIT', 'BSP'].includes(code);
  return currency(amount, isInUSD, false, code);
};
